import { toast } from 'sonner';
import { toErrorMessage } from './formatApiError';

export function toastSuccess(message, opts = {}) {
  return toast.success(message, { duration: 3500, ...opts });
}

export function toastError(message, opts = {}) {
  return toast.error(toErrorMessage(message), { duration: 5000, ...opts });
}

export function toastInfo(message, opts = {}) {
  return toast.message(message, { duration: 4000, ...opts });
}

export function toastWarning(message, opts = {}) {
  return toast.warning(message, { duration: 4500, ...opts });
}

/** Wrap any async action with optional success/error toasts (all portals / roles). */
export async function runWithToast(action, options = {}) {
  const {
    successMessage,
    errorMessage,
    silent = false,
    onSuccess,
    onError,
  } = options;
  try {
    const result = await (typeof action === 'function' ? action() : action);
    if (!silent && successMessage) toastSuccess(successMessage);
    onSuccess?.(result);
    return result;
  } catch (err) {
    if (!silent) {
      toastError(errorMessage || toErrorMessage(err));
    }
    onError?.(err);
    throw err;
  }
}
